import { colors } from '../../colors';
var para = {
  messageColor: colors.red
};
export default para;